export default class User {
    constructor({ name, role, permissions, companyId, isOneJobPassword, serverPermissions, defaultCompanyId, allowedUnits, type, autoLubeReport = false, jobPlanner = false, map = false, fleetView = false, fleetViewAllSources = false, apiKeys = false, wellboreData = false }) {

        this.name = name;
        this.role = role;
        this.companyId = companyId;
        this.isOneJobPassword = isOneJobPassword;
        this.defaultCompanyId = defaultCompanyId;
        this.allowedUnits = allowedUnits || null;
        this.type = type;
        this.autoLubeReport = autoLubeReport;
        this.jobPlanner = jobPlanner;
        this.map = map;
        this.fleetView = fleetView;
        this.fleetViewAllSources = fleetViewAllSources;
        this.apiKeys = apiKeys;
        this.wellboreData = wellboreData;

        if (!permissions) {
            this.permissions = [];
        } else {
            this.permissions = typeof permissions === 'string' ? [permissions] : permissions;
        }

        if (!serverPermissions) {
            this.serverPermissions = [];
        } else {
            this.serverPermissions = typeof serverPermissions === 'string' ? [serverPermissions] : serverPermissions;
        }
    }

    isSuperuser() {
        return this.role === 'superuser' || this.role === 'master';
    }

    isRoot() {
        return this.role === 'root';
    }

    isMaster() {
        return this.role === 'master';
    }

    isAdmin() {
        return this.role === 'admin';
    }

    isRegularUser() {
        return this.role === 'user';
    }

    canExportCsv() {
        return this.permissions.includes('export_csv');
    }

    showAutoLubeReport() {
        return !!this.autoLubeReport;
    }

    showJobPlanner() {
        return !!this.jobPlanner;
    }

    showMap() {
        return !!this.map;
    }

    showFleetView() {
        return !!this.fleetView;
    }

    showApiKeys() {
        return !!this.apiKeys;
    }

    showWellboreData() {
        return !!this.wellboreData;
    }

    canManageMasters() {
        return this.permissions.includes('data_usage');
    }

    canManageTemplates() {
        return this.permissions.includes('manage_templates');
    }

    allowDataUsage() {
        return this.permissions.includes('data_usage');
    }

    allowSystemUsage() {
        return this.permissions.includes('system_usage');
    }

    allowSystemSettings() {
        return this.permissions.includes('system_settings');
    }

    allowSystemTab() {
        return this.allowSystemUsage() || this.allowSystemSettings();
    }

    allowMms() {
        return this.permissions.includes('mms') && this.serverPermissions.includes('mms');
    }

    allowUiMms() {
        return this.permissions.includes('mms');
    }
    allowUiIntegrations() {
        return this.permissions.includes('integrations');
    }
    allowUiDevices() {
        return this.permissions.includes('devices');
    }
    allowUiMap() {
        return !!this.map;
    }

    allowUiFleetView() {
        return !!this.fleetView;
    }

    // Pumps of every job type, not only MPC Units jobs: no MPC fleet layout (status grid, manifold) to show for them
    isFleetViewAllSources() {
        return !!this.fleetView && !!this.fleetViewAllSources;
    }

    allowUiApiKeys() {
        return !!this.apiKeys;
    }

    allowUiWellboreData() {
        return !!this.wellboreData;
    }

    canManageUnitSettings() {
        return !this.isOneUnitPassword() && (this.isSuperuser() || this.isMaster() || this.isRoot() || this.isAdmin());
    }

    canChangeApiKeyRateLimits() {
        return this.isSuperuser() || this.isRoot() || this.isAdmin();
    }

    hasAllowedUnits() {
        return this.allowedUnits && Array.isArray(this.allowedUnits) && this.allowedUnits.length > 0;
    }
    isOneUnitPassword() {
        return this.type === 'oup';
    }
}
